import {
  VENDOR_LIST,
  VENDOR_ALLOCATE,
  VENDOR_SERVICE_DETAIL,
  POST_VENDOR_SERVICE
} from "./type";

const initialState = {
  vendorList: [],
  vendorAllocate: {},
  vendorServiceDetail: {},
  postVendorService: {}
}

const vendorReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case VENDOR_LIST:
      return {
        ...state,
        vendorList: payload,
      };
    case VENDOR_ALLOCATE:
      return {
        ...state,
        vendorAllocate: payload,
      };
    case VENDOR_SERVICE_DETAIL:
      return {
        ...state,
        vendorServiceDetail: payload,
      };
    case POST_VENDOR_SERVICE:
      return {
        ...state,
        postVendorService: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default vendorReducer;